import { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import {
  Button,
  Dialog,
  DialogActions,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { useApi } from '../../hooks/useApi';
import { Agent } from '../../types/agents';

interface IAgentModalProps {
  isOpen: boolean;
  onClose: () => void;
  agentId: string;
  setAgent: (id: string) => void;
}

export const AgentModal = ({ isOpen, onClose, agentId, setAgent }: IAgentModalProps) => {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [selectedAgent, setSelectedAgent] = useState(agentId);
  const { user } = useUser();
  const { apiFetch } = useApi();

  useEffect(() => {
    if (!user?.id) return;

    (async () => {
      try {
        const res = await apiFetch('agents');
        const data: Agent[] = await res.json();

        setAgents(data);
      } catch (e) {
        console.log('Something went wrong', e);
      }
    })();
  }, [user?.id]);

  const handleSelectAgent = () => {
    setAgent(selectedAgent);
    localStorage.setItem('agent', selectedAgent);
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      fullWidth
      disableEscapeKeyDown
    >
      <Stack
        gap={2}
        pt={4}
        px={3}
      >
        <Typography variant="h5">Select Agent</Typography>
        <TextField
          select
          fullWidth
          onChange={(e) => setSelectedAgent(e.target.value)}
          value={selectedAgent}
          variant="outlined"
        >
          <MenuItem value="">Select an agent</MenuItem>

          {agents?.map((agent) => (
            <MenuItem
              key={agent.id}
              value={agent.id}
            >
              {agent.name}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
      <DialogActions>
        {!!agentId && (
          <Button
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </Button>
        )}
        <Button
          variant="contained"
          onClick={handleSelectAgent}
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};
